'use client';

import { useRef, useState } from 'react';

import { HomePageDocument } from '../../../../../resources/homePageDocument/domain/types/homePageDocument';
import { useTrackBlockViewed } from '../../../../../shared/hooks/useTrackBlockViewed';
import { ThematicCard } from '../ThematicCard/ThematicCard';

import style from './Thematics.module.css';

type MarketingThematicsProps = {
    thematics: HomePageDocument['marketingThematics'];
};

export function MarketingThematics({ thematics }: MarketingThematicsProps) {
    const [lastHovered, setLastHovered] = useState(1);
    const sectionRef = useRef<HTMLDivElement>(null);

    useTrackBlockViewed(sectionRef, 'themes_inspiration');

    return (
        <div ref={sectionRef} className={style.container}>
            <div className={style.scrollableContainer}>
                {thematics.map((marketingArticle, index) => (
                    <ThematicCard
                        key={index}
                        title={marketingArticle.title}
                        description={marketingArticle.description}
                        link={marketingArticle.link}
                        image={marketingArticle.image}
                        isHovered={lastHovered === index}
                        onMouseEnter={() => {
                            setLastHovered(index);
                        }}
                        trackingInformation={{
                            click: {
                                block: 'themes_inspiration',
                                card_number: index + 1,
                            },
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
